/**
 * 业务错误类
 * 由 service 层在检查 ApiResponse.status !== 0 后抛出
 */
export class RequestError extends Error {
    /** 业务错误码 (ApiResponse.status) */
    status: number;

    constructor(message: string, status: number) {
        super(message);
        this.name = 'RequestError';
        this.status = status;
    }
}
